import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS, SOCIAL, WHATSAPP, ROUTES, serviceUrl } from '../../data/pmContent';
import {
  IconPin, IconPhone, IconMail,
  IconFacebook, IconInstagram, IconYoutube, IconTiktok, IconWhatsapp,
} from './PmIcons';

export default function PmFooter() {
  return (
    <div className="pm-scope">
      <footer className="footer">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <img src={BUSINESS.logo} srcSet={`${BUSINESS.logo} 1x, ${BUSINESS.logo2x} 2x`} alt={BUSINESS.name} width="56" height="56" loading="lazy" />
              <p>Estudio de belleza integral en Los Prados, Santo Domingo. Salga a brillar con nuestros servicios.</p>
              <div className="social">
                <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><IconFacebook /></a>
                <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><IconInstagram /></a>
                <a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><IconYoutube /></a>
                <a href={SOCIAL.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><IconTiktok /></a>
                <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><IconWhatsapp /></a>
              </div>
            </div>

            <div>
              <h4>Nosotros</h4>
              <ul>
                <li><Link to={ROUTES.nosotros}>Quiénes somos</Link></li>
                <li><Link to={ROUTES.precios}>Precios</Link></li>
                <li><Link to={ROUTES.agendar}>Agendar cita</Link></li>
                <li><Link to="/#servicios">Servicios</Link></li>
                <li><Link to="/#membresias">Membresías</Link></li>
                <li><Link to="/#faq">Preguntas frecuentes</Link></li>
              </ul>
            </div>

            <div>
              <h4>Servicios</h4>
              {/* Enlaces corregidos: los del sitio actual (beauty-lashes-brows,
                  beauty-makeup, beauty-hair) devuelven "Servicio no encontrado". */}
              <ul>
                <li><Link to={serviceUrl('maquillaje-semi-permanente')}>Microblading</Link></li>
                <li><Link to={serviceUrl('cejas-pestanas')}>Pestañas</Link></li>
                <li><Link to={serviceUrl('maquillajes')}>Maquillaje</Link></li>
                <li><Link to={serviceUrl('peluqueria')}>Salón de belleza</Link></li>
              </ul>
            </div>

            <div>
              <h4>Contáctanos</h4>
              <address>
                <a href={BUSINESS.mapsUrl} target="_blank" rel="noopener noreferrer">
                  <IconPin />
                  <span>Calle Juan Isidro Ortega #302,<br />Los Prados, Santo Domingo, D.N.</span>
                </a>
                <a href={`mailto:${BUSINESS.email}`}><IconMail /> {BUSINESS.email}</a>
                <a href={`tel:${BUSINESS.phone1Tel}`}><IconPhone /> {BUSINESS.phone1}</a>
                <a href={`tel:${BUSINESS.phone2Tel}`}><IconPhone /> {BUSINESS.phone2}</a>
              </address>
            </div>
          </div>

          <div className="footer__bottom">
            <span>© {new Date().getFullYear()} {BUSINESS.name}. Todos los derechos reservados.</span>
            <span>
              Desarrollado por:{' '}
              <a href="https://www.coralanmultiservice.com/" target="_blank" rel="noopener noreferrer">Coralan Multiservice</a>
            </span>
          </div>
        </div>
      </footer>

      <a className="wa-float" href={WHATSAPP} target="_blank" rel="noopener noreferrer" aria-label="Escribir por WhatsApp">
        <IconWhatsapp />
      </a>
    </div>
  );
}
